export default {"src":"/_next/static/media/ico3.38106d39.svg","height":44,"width":68,"blurWidth":0,"blurHeight":0};